import AnimatedCounter from "./AnimatedCounter";
import { PROFILE_IMAGE } from "../config";

export default function About({ t }) {
  return (
    <section id="ueber" className="about-section" data-testid="about-section">
      <div className="section-inner">
        <div className="about-grid">
          <div className="about-image-col fade-in-left">
            <div className="about-image-wrapper">
              <div className="about-accent-line" aria-hidden="true" />
              <img src={PROFILE_IMAGE} alt="Dominik Mietke – Gründer von UNDRIVE" className="about-photo" loading="lazy" width="400" height="400" />
            </div>
          </div>
          <div className="about-text-col fade-in-right" style={{ transitionDelay: "0.15s" }}>
            <div className="section-label">{t.aboutLabel}</div>
            <h2 className="section-title light">{t.aboutTitle}</h2>
            <p className="about-lead">{t.aboutLead}</p>
            <p className="about-text">{t.aboutText}</p>
            <div className="stats-row">
              <AnimatedCounter end={22} suffix="+" label={t.stat1} />
              <AnimatedCounter end={15} suffix=".000+" label={t.stat2} />
            </div>
            <a href="#kontakt" className="btn-primary" data-testid="about-cta">
              {t.ctaPrimary}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
